import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";

const Table = ({ files, setCurrentrequest }) => {
  // const [status, setStatus] = useState("available");
  // const [filemovement, setfilemovement] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [data, setData] = useState([]);
  const [filetoshow, setFiletoshow] = useState(" ");

  useEffect(() => {
    // files.map((item, i) => data.push({ name: item.name, status: item.status }));
    setData(
      files.map((item, index) => ({
        sno: index + 1,
        id: item.id,
        name: item.name,
        publishername: "Publishername",
        journalname: "Journalname",
        status: item.status,
        time: item.time,
      }))
    );
  }, [files]);

  useEffect(() => {
    let split;
    if (filetoshow) {
      split = filetoshow.split(" = ");
    }
    setCurrentrequest({ c_id: split[0], exits: split[1] });
  }, [filetoshow]);

  const columns = [
    {
      name: "S.No",
      selector: (row) => row.sno,
      sortable: true, // Enable sorting
      width: "80px",
    },
    {
      name: "File ID",
      selector: (row) => row.id,
      sortable: true, // Enable sorting
      width: "8%",
    },
    {
      name: "File Name",
      selector: (row) => row.name,
      sortable: true,
      width: "15%",
    },
    {
      name: "Publisher Name",
      selector: (row) => row.publishername,
      sortable: true,
    },
    {
      name: "Journal Name",
      selector: (row) => row.journalname,
      sortable: true,
    },
    {
      name: "Upload Time",
      selector: (row) => row.time,
      sortable: true,
    },
    {
      name: "Report",
      cell: (row) =>
        row.status === "3" ? (
          <Link to={`/report/${row.id}`} className="text-154A79 underline">
            View Report
          </Link>
        ) : (
          <span className="text-gray-400">Report Unavailable</span>
        ),
    },
    {
      name: "File Status",
      cell: (row) => (
        <div
          className={`px-[10px] py-[12px] w-[90%] text-white rounded-[12px] ${
            row.status === "3"
              ? "bg-259323"
              : row.status === "2"
              ? "bg-FEB13F"
              : row.status === "1"
              ? "bg-[#d3442e]"
              : "bg-[#163793]"
          }`}
        >
          {row.status === "3" ? (
            <span>Report Generated</span>
          ) : row.status === "2" ? (
            <span className="text-white">Processing...</span>
          ) : row.status === "1" ? (
            <span className="text-white">Yet to Process</span>
          ) : row.status === "0" ? (
            <span className="text-white">Uploading file</span>
          ) : (
            <span className="text-white">File not found</span>
          )}
        </div>
      ),
    },
    // {
    //   name: "Option",
    //   cell: (row) => (
    //     <button
    //       className={`px-[10px] py-[12px] w-[90%] text-white rounded-[12px] bg-E63946 ${
    //         status === "available" ? "opacity-[100%]" : "opacity-[60%]"
    //       }`}
    //       disabled={status === "busy"}
    //     >
    //       File Movement
    //     </button>
    //   ),
    // },
  ];

  const filteredData = data.filter((item) =>
    item.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleSelect = (e) => {
    setFiletoshow(e.target.value);
  };

  // const sortedData = [...filteredData].sort((a, b) => {
  //   // Replace 'name' with the field you want to sort by
  //   if (a.name < b.name) return 1; // Swap the order for descending sort
  //   if (a.name > b.name) return -1;
  //   return 0;
  // });

  const customStyles = {
    headCells: {
      style: {
        backgroundColor: "#ffffff", // Header background color
        color: "#050505", // Header text color
        fontSize: "14px", // Font size of header text
        fontWeight: "semibold", // Bold header text
      },
    },
    rows: {
      style: {
        minHeight: "72px", // Override row height
        color: "#050505",
      },
      stripedStyle: {
        backgroundColor: "#F8F9FA", // Stripe background color
      },
    },
    pagination: {
      style: {
        backgroundColor: "#f7fafc", // Pagination background color
      },
      pageButtonsStyle: {
        borderRadius: "50%", // Rounded pagination buttons
        height: "40px",
        width: "40px",
        padding: "8px",
        margin: "0 4px",
        cursor: "pointer",
        backgroundColor: "#e2e8f0", // Button background color
        color: "#2d3748", // Button text color
        "&:hover": {
          backgroundColor: "#cbd5e0", // Hover background
          color: "#1a202c", // Hover text color
        },
        "&:disabled": {
          backgroundColor: "#edf2f7", // Disabled button background
          color: "#a0aec0", // Disabled button text color
        },
      },
    },
  };

  return (
    <div className="w-full flex flex-col p-10">
      <div className="flex items-center justify-between">
        <h1 className="text-154A79 text-24 font-semibold">File History</h1>
        <div className="py-3 px-2 rounded-[12px] border border-gray-300">
          <select
            value={filetoshow}
            onChange={handleSelect}
            className="outline-none"
          >
            <option>Select to Filter</option>
            <option value={" "}>Show all</option>
            <optgroup label="Author Department Relevance to Journal">
              <option value={"26 = True"}>
                Author Department Relevance to Journal True
              </option>
              <option value={"26 = False"}>
                Author Department Relevance to Journal False
              </option>
            </optgroup>
            <optgroup label="Reference Relevance to Journal">
              <option value={" 24 = True"}>
                {" "}
                Reference Relevance to Journal True
              </option>
              <option value={"24 = False"}>
                Reference Relevance to Journal False
              </option>
            </optgroup>
          </select>
        </div>
        <div className="border border-gray-300 rounded-[12px] flex w-fit items-center p-1">
          <div>
            <img
              src={process.env.PUBLIC_URL + "/images/history/search.png"}
              alt="search_icon"
              className="h-auto w-auto"
            ></img>
          </div>
          <input
            type="text"
            placeholder="Search by file name..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="p-2 "
          />
        </div>
      </div>
      <div className="border-[1px] border-C4C8CC mt-10">
        {/* DataTable component */}
        <DataTable
          columns={columns}
          data={filteredData}
          pagination // Enable pagination
          highlightOnHover // Highlight row on hover
          striped // Add striping to rows
          defaultSortField="name" // Set default sort column
          customStyles={customStyles}
        />
      </div>
    </div>
  );
};

export default Table;
